import { MyBiographies } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.MYBIOGRAPHIES.path,
      name: "My Memorials",
      key: routesMap.MYBIOGRAPHIES.path,
      commonRoute: false,
      private: true,
      withAuth: false,
      belongsToHeader: true,
      element: <MyBiographies />,
    },
  ];
}
